import { EditAccountPermissionsRequest, SubAccountPermissionSection, SubAccountPermissionsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useSubAccountPermissions() {
  const [fetchingPermissions, setFetchingPermissions] = useState(false);
  const [permissions, setPermissions] = useState<SubAccountPermissionSection[]>([]);

  async function fetchSubAccountPermissions(params: SubAccountPermissionsRequest) {
    try {
      setPermissions([]);
      setFetchingPermissions(true);
      const res = await api.fetchSubAccountPermissions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setPermissions(res.PermissionValues);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingPermissions(false);
    }
  }

  async function saveSubAccountPermissions(params: EditAccountPermissionsRequest) {
    try {
      const res = await api.saveSubAccountPermissions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return {
    fetchingPermissions,
    permissions,
    fetchSubAccountPermissions,
    saveSubAccountPermissions,
  };
}
